export enum WorkflowConfigRoleAssignmentType {
    REQUIRED = 'required',
    OPTIONAL = 'optional'
}
